import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CatalogSearchRequest} from '../catalog/catalog.service';
import {AdminLabelingSkuInfo, AdminLabelingSkuListResponse} from '../../models/labeling/label-history.model';
import {AdminLabelSkuTagType} from '../../models/labeling/label-tag-type.model';

@Injectable({
  providedIn: 'root'
})
export class QueryTagsService {
  private readonly baseUrl = `${environment.backend.url}/api/labeling/catalog/v1`;

  constructor(private readonly http: HttpClient) {}

  search(req: CatalogSearchRequest): Observable<AdminLabelingSkuListResponse> {
    let params = new HttpParams();

    if (req.productId != null) params = params.set('productId', String(req.productId));
    if (req.refId != null && req.refId !== '') params = params.set('refId', req.refId);
    if (req.skuId != null) params = params.set('skuId', String(req.skuId));
    if (req.productName != null && req.productName !== '') params = params.set('productName', req.productName);

    if (req.size != null) params = params.set('size', String(req.size));
    params = params.set('order', (req.order ?? 'DESC'));
    params = params.set('orderBy', 'Date');

    if (req.after != null) params = params.set('after', String(req.after));
    if (req.afterDate != null) params = params.set('afterDate', req.afterDate);
    if (req.before != null) params = params.set('before', String(req.before));
    if (req.beforeDate != null) params = params.set('beforeDate', req.beforeDate);

    return this.http.get<AdminLabelingSkuListResponse>(`${this.baseUrl}/search`, { params });
  }

  getTypes(): Observable<AdminLabelSkuTagType[]> {
    return this.http.get<AdminLabelSkuTagType[]>(`${this.baseUrl}/tag-types`)
  }

  getBySkuId(skuId: number): Observable<AdminLabelingSkuInfo> {
    return this.http.get<AdminLabelingSkuInfo>(`${this.baseUrl}/stock-keeping-unit/${skuId}`);
  }
}
